import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Role } from '../models/role.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class RoleService{
   public url: string;
   public user_id:number;

   constructor(
     public _http: Http,
     public VariableService: VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.VariableService.getCookie('user_id'));
   }

   getRoles()
   {
     return this._http.get(this.url+'roles/'+this.user_id).map(res => res.json());
   }

   getRole()
   {
     return "getRole from service";
   }

   addRole(role: Role)
   {
     let json = JSON.stringify(role);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-role/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateRole(id:number,pRole: Role)
   {
     let json = JSON.stringify(pRole);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-role/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteRole(id:number)
   {
     return this._http.get(this.url+'delete-role/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/role.service.ts